import { endpoints } from '@/services/endpoints';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';
import { AppCard } from '@/components/ui/AppCard';
import { AppPieChart } from '@/components/charts/pieChart/AppPieChart';

export default function TicketChartsByStatus() {
  const { data: ticketsByStatus, isLoading } = useQuery({
    queryKey: ['ticketStatus'],
    queryFn: () => axiosGetRequest(endpoints.getTicketByStatus),
  });
  const totalStatus = ticketsByStatus?.totalCount || 'N/A';
  const config = {
    count: {
      label: 'Total tickets',
      color: '#0D9373',
    },
    accepted: {
      label: 'Accepted',
      color: '#10B981',
    },
    resolved: {
      label: 'Resolved',
      color: '#3B82F6',
    },
    pending: {
      label: 'Pending',
      color: '#F59E0B',
    },
  };

  return (
    <AppCard>
      <h4 className="mb-4 text-base font-semibold text-coal-900">Tickets by Status</h4>
      <AppPieChart
        chartData={ticketsByStatus?.data}
        dataKey="count"
        nameKey="status"
        config={config}
        innerData={{ value: totalStatus, title: 'Total' }}
        isLoading={isLoading}
      />
    </AppCard>
  );
}
